/**
 * Возвращает следующий по порядку id
 */
export const getNextId = (array) => {
  if (!array || !array.length) {
    return 1
  }

  const maxId = Math.max(...array.map(item => item.id || 0))
  return maxId + 1
}
